import type { AreaCatalog } from '../area';
import type { item as en } from '../en/item';

export const item = {
  // --- Route frames ---
  'item.peek.loading': 'Wird geladen',
  'item.route.notFound': 'Diese Aufgabe gibt es nicht, oder du kannst sie nicht sehen.',
  'item.border.private':
    'Diese Aufgabe ist privat. Du siehst, dass es sie gibt und womit sie verknüpft ist, aber nicht ihren Inhalt, solange du dort keine Rolle hast.',
  'item.border.privateOwned':
    'Diese Aufgabe ist privat. Du siehst, dass es sie gibt, dass {owner} sie verantwortet und womit sie verknüpft ist, aber nicht ihren Inhalt, solange du dort keine Rolle hast.',
  'item.border.connectsTo': {
    one: 'Verknüpft mit · {count} Aufgabe',
    other: 'Verknüpft mit · {count} Aufgaben',
  },
  'item.border.noNeighbours': 'Keine sichtbaren verknüpften Aufgaben.',
  'item.border.relation.parent': 'übergeordnet',
  'item.border.relation.child': 'Unteraufgabe',
  'item.border.relation.contributesTo': 'davon hängt ab',
  'item.border.relation.dependsOn': 'hängt ab von',
  'item.border.relation.related': 'verwandt',
  // --- Head ---
  'item.parents.in': 'in',
  'item.parents.more': 'Weitere übergeordnete Aufgaben',
  'item.title.label': 'Titel der Aufgabe',
  'item.title.rename': 'Umbenennen',
  'item.title.copyLink': 'Link kopieren',
  'item.title.copied': 'Kopiert',
  // --- State line ---
  'item.state.verdict.accepted': 'Abgenommen',
  'item.state.verdict.denied': 'Abnahme verweigert',
  'item.state.tip.active': 'Als in Arbeit markiert.',
  'item.state.tip.finding.activeAllSettled': 'Noch aktiv, obwohl alle Unteraufgaben erledigt sind.',
  'item.state.tip.finding.doneOpenChildren': 'Fertig, aber Unteraufgaben sind noch offen.',
  'item.state.tip.finding.cycle': 'Steckt in einem Kreis aus Abhängigkeiten.',
  'item.state.tip.finding.deadlock': 'Steckt in einer Blockade: die Aufgaben warten aufeinander.',
  'item.state.tip.idle': 'Nicht als in Arbeit markiert.',
  'item.state.tip.review': 'Fertig, und wartet auf die Review.',
  'item.state.tip.accepted': 'Die Review hat die Arbeit angenommen.',
  'item.state.tip.denied': 'Die Review hat die Arbeit abgelehnt, deshalb ist sie wieder offen.',
  'item.state.tip.done': 'Erledigt.',
  'item.state.tip.cancelled': 'Beendet, ohne dass die Arbeit getan wurde.',
  'item.state.add': 'Status hinzufügen',
  'item.state.health': 'Zustand',
  'item.health.dot': 'Zustand: {summary}',
  'item.health.nothingDeclared': 'nichts angegeben',
  'item.health.menu': 'Angegebener Zustand',
  'item.health.onTrack': 'Auf Kurs',
  'item.health.clearsAll': 'hebt alle gesetzten Zustände auf',
  'item.health.concern': 'Bedenken',
  'item.health.markCritical': '{state}: auf kritisch setzen',
  'item.health.pageCost': 'Benachrichtigt Beteiligte und Abonnierende.',
  'item.health.automatic': '{state} (automatisch)',
  'item.health.unrequestedTip':
    'Niemand will das Ergebnis mehr. Wer es braucht, trägt sich unter Verantwortlich ein.',
  'item.health.pill': '{state}, gesetzt von {names}',
  'item.health.byFlow': 'laut {flow}',
  'item.health.remove': 'Entfernen',
  'item.suggest.count': { one: '{count} Vorschlag', other: '{count} Vorschläge' },
  'item.suggest.label': 'Vorschläge',
  'item.suggest.tip': 'Aussagen zu dieser Aufgabe und die Aktionen, die sie beantworten würden.',
  'item.suggest.rule': 'Die Regel ({flow})',
  'item.suggest.notYours': 'liegt nicht bei dir',
  'item.suggest.inRoleRequester': 'Verantwortlich: {names}',
  'item.suggest.inRoleEditor': 'Darf bearbeiten · {names}',
  // --- Statements ---
  'item.statement.adopt': 'Auf {state} setzen',
  'item.statement.adoptCost': 'ein Zustand in deinem Namen, mit Verweis hierauf',
  'item.statement.contain': 'Nicht betroffen',
  'item.statement.containCost': 'geht nicht an Aufgaben weiter, die von dieser abhängen',
  'item.statement.addNote': 'Notiz hinzufügen…',
  'item.statement.noteLabel': 'Notiz zu dieser Aussage',
  'item.statement.noteSubmit': 'Notiz hinzufügen',
  'item.statement.noteCancel': 'Abbrechen',
  'item.statement.value.end': 'Ende',
  'item.statement.value.start': 'Beginn',
  'item.statement.value.noActivity': 'Keine Aktivität',
  'item.statement.value.goalUntended': 'Ziel nicht gepflegt',
  'item.statement.value.dependents': 'Abhängige Aufgaben',
  'item.statement.value.readyDependents': 'Wartende abhängige Aufgaben',
  'item.statement.value.noRequester': 'Verwaist',
  'item.statement.value.noContributor': 'Keine Zuständigen',
  'item.statement.value.drift.doneOpenChildren': 'Fertig, darunter offen',
  'item.statement.value.drift.activeAllSettled': 'Aktiv, darunter alles erledigt',
  'item.statement.value.deadlock': 'Gegenseitige Blockade',
  'item.statement.value.cycle': 'Kreis aus Abhängigkeiten',
  'item.statement.value.unknownParticipants': 'mit unbekannten Teilnehmern',
  'item.statement.value.viaUnknown': 'über unbekannte Aufgaben',
  'item.statement.value.statement': 'Eine Aussage',
  'item.statement.signWords': ', {statement}',
  // --- Needs you ---
  'item.attention.takeUp': 'Annehmen',
  'item.attention.decline': 'Ablehnen',
  'item.attention.deliveredBy': '{name} hat die Aufgabe bereit zur Review gemeldet.',
  'item.attention.delivered': 'Die Aufgabe ist bereit zur Review.',
  'item.attention.reviewAsk': 'Die Review liegt bei dir: annehmen oder ablehnen.',
  'item.attention.dismiss': 'Ausblenden',
  'item.conclusion.finishWith': 'Mit fertigstellen: {title}',
  'item.conclusion.cancelWith': 'Mit abbrechen: {title}',
  'item.conclusion.listed': 'eine andere Liste enthält sie',
  'item.conclusion.needed': 'andere Aufgaben brauchen sie',
  'item.conclusion.finishOnly': 'Nur diese fertigstellen',
  'item.conclusion.cancelOnly': 'Nur diese abbrechen',
  'item.conclusion.finishMore': {
    one: 'Diese und {count} weitere fertigstellen',
    other: 'Diese und {count} weitere fertigstellen',
  },
  'item.conclusion.cancelMore': {
    one: 'Diese und {count} weitere abbrechen',
    other: 'Diese und {count} weitere abbrechen',
  },
  // --- Meta group ---
  'item.meta.flowDistribution': 'darunter: {flows}',
  'item.meta.flowCounts': '{flow}: {counts}',
  'item.meta.flowCount': '{count} in {stage}',
  'item.meta.flowDistributionTip':
    'Abgeleitet aus den Unteraufgaben dieser Aufgabe, die in einem Ablauf sind. Nur ein Hinweis: steht neben dem angegebenen Status der Aufgabe und wird nie zurückgeschrieben. Die Aufnahme in einen Ablauf gilt nie für Unteraufgaben mit.',
  'item.properties.title': 'Details',
  'item.properties.requestedBy': 'Verantwortlich',
  'item.properties.requestedByTip': 'Benötigt das Ergebnis und hat die Aufgabe in Auftrag gegeben',
  'item.properties.review': 'Review',
  'item.properties.reviewTip':
    'Ob die Arbeit durch eine Review geht, bevor sie fertig ist. Die Verantwortlichen legen es fest.',
  'item.properties.reviewRequired': 'Erforderlich',
  'item.properties.reviewOptional': 'Nicht erforderlich',
  'item.properties.reviewByFlow': 'Der Flow verlangt trotzdem eine Review.',
  'item.properties.tags': 'Tags',
  'item.properties.created': 'Erstellt',
  'item.properties.updated': 'Aktualisiert',
  'item.viewContext.via': 'Über das Board {board}',
  'item.viewContext.lane': 'Spalte',
  'item.viewContext.unset': 'Nicht gesetzt',
  'item.viewContext.unassigned': 'Nicht zugeordnet',
  'item.views.label': 'Boards',
  'item.views.add': 'Zu einem Board hinzufügen',
  'item.views.board': 'Board',
  'item.views.titleRootChecklist': 'Ein Board ihrer Unteraufgaben, als Checkliste',
  'item.views.titleRootList': 'Ein Board ihrer Unteraufgaben, als Liste',
  'item.views.titleRootBoard': 'Ein Board ihrer Unteraufgaben, als Kanban',
  'item.views.titlePinBoard': 'Zu diesem Board hinzugefügt',
  'item.views.titleParent': 'Auf diesem Board über die übergeordnete Aufgabe',
  'item.views.titleAncestor': 'Auf diesem Board über eine Aufgabe darüber',
  'item.views.relRoot': 'ihre Unteraufgaben',
  'item.views.relParent': 'über die übergeordnete Aufgabe',
  'item.views.relAncestor': 'über eine Aufgabe darüber',
  'item.views.unpin': 'Lösen',
  'item.views.unpinFrom': 'Von „{view}“ lösen',
  'item.views.hide': 'Ausblenden',
  'item.views.hideOn': 'In „{view}“ ausblenden',
  'item.views.search': 'Zu einem Board hinzufügen…',
  'item.views.searchLabel': 'Zu einem Board hinzufügen',
  'item.views.boards': 'Boards',
  'item.views.noMatch': 'Kein Board passt.',
  'item.views.noBoards': 'Kein weiteres Board zum Hinzufügen.',
  'item.views.reasonViewRole': 'du siehst dieses Board, kannst es aber nicht pflegen',
  'item.views.reasonShare':
    'geteiltes Board: Zum Hinzufügen brauchst du Zugriff als Verwaltende auf die Aufgabe',
  'item.views.newChecklist': 'Neues Board ihrer Unteraufgaben, als Checkliste',
  'item.views.newBoard': 'Neues Board ihrer Unteraufgaben, als Kanban',
  'item.views.newLabel': 'Neues Board',
  // --- Seats ---
  'item.seats.contributor.empty':
    'Zuständigkeit offen: selbst übernehmen oder festlegen, wer zuständig ist',
  'item.seats.contributor.title': 'Selbst übernehmen oder festlegen, wer zuständig ist',
  'item.seats.contributor.menu': 'Zuständig',
  'item.seats.contributor.word': 'Zuständig',
  'item.seats.contributor.holder': 'Zuständig: {names}',
  'item.seats.requester.nobody': 'niemand',
  'item.seats.requester.empty': 'Verantwortung offen: Verantwortliche festlegen',
  'item.seats.requester.title': 'Verantwortliche festlegen',
  'item.seats.requester.menu': 'Verantwortlich',
  'item.seats.remove': '{name} entfernen',
  'item.seats.offered': 'angeboten',
  'item.seats.offeredTo': 'Angeboten an {name}.',
  'item.seats.takeUp': 'Übernehmen',
  'item.seats.takeUpForGroup': 'Für die Gruppe übernehmen',
  'item.seats.declineOffer': 'Dieses Angebot ablehnen',
  'item.seats.withdrawOffer': 'Angebot an {name} zurückziehen',
  'item.seats.takeThisOn': 'Selbst übernehmen',
  'item.seats.takeThisOnHint': 'dich als zuständig eintragen',
  'item.seats.search': 'Personen suchen…',
  'item.seats.noOne': 'Niemand zum Hinzufügen.',
  'item.seats.needsDoing': 'Noch zu vergeben',
  'item.promise.title': 'Zur Zusage machen',
  'item.promise.subtitle':
    'Eine Vereinbarung der Verantwortlichen dieser Aufgabe. Die Zuständigkeit wird angeboten, nach den eigenen Regeln der Person, nie erzwungen.',
  'item.promise.prefill': '{title} fertig machen',
  'item.promise.field': 'Die Zusage',
  'item.promise.offeredTo': 'Angeboten an',
  'item.promise.offeredToHint':
    'Leer lassen, um sie den aktuellen Verantwortlichen der Aufgabe anzubieten. Deren Regeln entscheiden: direkt eingesetzt oder zur Übernahme angeboten.',
  'item.promise.chooseOther': 'Jemand anderen wählen',
  'item.promise.search': 'Personen und Gruppen suchen…',
  'item.promise.noOne': 'Niemand, dem du sie anbieten kannst.',
  'item.promise.neededBy': 'Benötigt bis',
  'item.promise.neededByHint': 'Optional, in jeder Genauigkeit: 2026-09-30, 2026-W40, 2026-Q4.',
  'item.promise.cancel': 'Abbrechen',
  'item.promise.confirm': 'Zur Zusage machen',
  // --- Access ---
  'item.access.title': 'Zugriff',
  'item.access.nobody': 'noch niemand hat Zugriff',
  'item.access.openToEveryone': 'für alle offen',
  'item.access.chainBroken': 'Vererbung unterbrochen',
  'item.access.hat.contributor': 'Zuständig',
  'item.access.hat.requester': 'Verantwortlich',
  'item.access.hat.both': 'Verantwortlich · Zuständig',
  'item.access.role.contributor': 'Zuständig',
  'item.access.role.contributorHint': 'macht die Arbeit',
  'item.access.role.requester': 'Verantwortlich',
  'item.access.role.requesterHint': 'verantwortet das Ergebnis',
  'item.access.role.maintainer': 'Verwaltende',
  'item.access.role.maintainerAddHint': 'verwaltet sie',
  'item.access.role.maintainerHint': 'verwaltet',
  'item.access.role.member': 'Mitglied',
  'item.access.role.memberAddHint': 'kann daran arbeiten',
  'item.access.role.memberHint': 'kann arbeiten',
  'item.access.role.viewer': 'Betrachtende',
  'item.access.role.viewerHint': 'kann sehen',
  'item.access.roleWord.viewer': 'Betrachtende',
  'item.access.roleWord.member': 'Mitglied',
  'item.access.roleWord.maintainer': 'Verwaltende',
  'item.access.path.requester': 'Verantwortlich',
  'item.access.path.requesterTitle': 'Verantwortet das Ergebnis',
  'item.access.path.coRequester': 'Verantwortet diese Aufgabe mit',
  'item.access.path.contributor': 'Zuständig',
  'item.access.path.contributorTitle': 'Macht die Arbeit',
  'item.access.path.coContributor': 'Arbeitet an dieser Aufgabe mit',
  'item.access.path.direct': 'direkt',
  'item.access.path.directTitle': 'Direkt auf dieser Aufgabe freigegeben: {role}',
  'item.access.path.inherited': 'geerbt',
  'item.access.path.inheritedFrom': '{role} geerbt von „{source}“',
  'item.access.path.inheritedFromStub': 'Geerbt von „{source}“',
  'item.access.path.inheritedFromUnknown': 'Geerbt von einer Aufgabe, die du nicht sehen kannst',
  'item.access.unknownSource': 'Geerbt von',
  'item.access.roleFor': 'Rolle von {name}',
  'item.access.directGrant': 'Direkte Freigabe: {role}',
  'item.access.remove': '{name} entfernen',
  'item.access.addPlaceholder': 'Personen und Gruppen hinzufügen…',
  'item.access.footnote': 'Änderungen am Zugriff stehen im Verlauf.',
  'item.access.invite.label': 'Per E-Mail einladen',
  'item.access.invite.placeholder': 'name@example.com',
  'item.access.invite.email': 'E-Mail-Adresse zum Einladen',
  'item.access.invite.role': 'Rolle der eingeladenen Person',
  'item.access.invite.send': 'Einladen',
  'item.access.invite.tag': '{status} · {role}',
  'item.access.invite.invited': 'eingeladen',
  'item.access.invite.expired': 'abgelaufen',
  'item.access.invite.revoke': 'Einladung für {email} widerrufen',
  // --- Files ---
  'item.doors.dependencies': { one: '{count} Abhängigkeit', other: '{count} Abhängigkeiten' },
  'item.doors.unread': { one: '{count} neu', other: '{count} neu' },
  'item.doors.activity': '{unread} · {time}',
  'item.files.title': 'Dateien',
  'item.files.add': 'Datei hinzufügen',
  'item.files.rowMenu': 'Datei „{name}“',
  'item.files.remove': 'Entfernen',
  'item.files.uploading': 'Wird hochgeladen',
  'item.files.uploadFailed': 'Die Datei wurde nicht hochgeladen.',
  'item.files.dismiss': 'Ausblenden',
  // --- Sections ---
  'item.sections.add': 'Abschnitt hinzufügen',
  'item.sections.description': 'Beschreibung',
  'item.sections.files': 'Dateien…',
  'item.sections.nothingToAdd': 'Nichts hinzuzufügen.',
  'item.sections.notSet': 'nicht gesetzt',
  'item.sections.noPosition': 'keine Position',
  'item.sections.restLine': '{label}: {value}',
  'item.sections.done': 'OK',
  'item.sections.remove': '{section} entfernen',
  'item.sections.removeTitle': '{section} von dieser Aufgabe entfernen.',
  'item.sections.removeConfirm': '{section} entfernen? Die Werte werden geleert.',
  'item.sections.confirmRemove': 'Entfernen bestätigen',
  'item.sections.confirmRemoveLabel': 'Entfernen von {section} bestätigen',
  'item.sections.flowFieldSet': 'Nur Felder, keine Phasen.',
  'item.sections.flowPosition': 'In {stage} · Phase {index} von {count}.',
  'item.sections.flowPositionGone':
    'Die Position „{key}“ gehört nicht mehr zu den Phasen dieses Ablaufs.',
  'item.sections.leave': 'aus Ablauf herausnehmen',
  'item.sections.leaveTitle':
    'Diese Aufgabe aus dem Ablauf herausnehmen. Ihre bisherige Position bleibt im Protokoll.',
  'item.sections.leaveConfirm':
    'Aus diesem Ablauf herausnehmen? Die bisherige Position bleibt im Protokoll.',
  'item.sections.confirmLeave': 'Herausnehmen bestätigen',
  'item.sections.allocation': 'Einsatz',
  'item.sections.overCommitted': 'über 1,0 FTE, überlastet',
  'item.sections.estimate': 'Schätzung',
  'item.sections.budget': 'Budget',
  'item.sections.unit.fte': 'FTE',
  'item.sections.unit.percent': '%',
  'item.sections.unit.days': 'Tage',
  'item.sections.unit.hours': 'Stunden',
  'item.sections.unit.weeks': 'Wochen',
  'item.sections.unit.months': 'Monate',
  'item.sections.unitCount.days': { one: '{count} Tag', other: '{count} Tage' },
  'item.sections.unitCount.hours': { one: '{count} Stunde', other: '{count} Stunden' },
  'item.sections.unitCount.weeks': { one: '{count} Woche', other: '{count} Wochen' },
  'item.sections.unitCount.months': { one: '{count} Monat', other: '{count} Monate' },
  'item.sections.cadence.oneTime': 'einmalig',
  'item.sections.cadence.perWeek': '/ Woche',
  'item.sections.cadence.perMonth': '/ Monat',
  'item.sections.cadence.perYear': '/ Jahr',
  'item.schedule.startLabel': 'Beginn',
  'item.schedule.endLabel': 'Ende',
  'item.schedule.durationLabel': 'Dauer',
  'item.schedule.cadenceLabel': 'Rhythmus',
  'item.schedule.everyWord': 'alle',
  'item.schedule.mode': 'Art der Angabe für {label}',
  'item.schedule.modeDate': 'Datum',
  'item.schedule.modeAfter': 'Nach Aufgabe',
  'item.schedule.anchor': 'Bezugsaufgabe',
  'item.schedule.chooseItem': 'Aufgabe wählen…',
  'item.schedule.resolves': 'steht fest, sobald {item} ein Datum hat',
  'item.schedule.thatItem': 'diese Aufgabe',
  'item.schedule.start': 'Beginn {date}',
  'item.schedule.end': 'Ende {date}',
  'item.schedule.after': 'nach {item}',
  'item.schedule.afterOffset': 'nach {item} + {amount}',
  'item.schedule.anItem': 'Aufgabe',
  'item.schedule.amountAsStored': '{value} {unit}',
  'item.schedule.every.days': { one: 'jeden Tag', other: 'alle {count} Tage' },
  'item.schedule.every.hours': { one: 'jede Stunde', other: 'alle {count} Stunden' },
  'item.schedule.every.weeks': { one: 'jede Woche', other: 'alle {count} Wochen' },
  'item.schedule.every.months': { one: 'jeden Monat', other: 'alle {count} Monate' },
  'item.schedule.everyAsStored': 'alle {value} {unit}',
  'item.schedule.conflictDependents': {
    one: 'kollidiert mit dem Zeitplan von {count} abhängigen Aufgabe',
    other: 'kollidiert mit den Zeitplänen von {count} abhängigen Aufgaben',
  },
  'item.schedule.conflictDependencies': {
    one: 'das angegebene Ende einer Abhängigkeit liegt nach diesem Datum',
    other: 'die angegebenen Enden von {count} Abhängigkeiten liegen nach diesem Datum',
  },
  'item.sections.editField': '{field} bearbeiten',
  'item.sections.addField': '{field} hinzufügen…',
  'item.sections.defined': { one: '{count} festgelegt', other: '{count} festgelegt' },
  'item.sections.noneDefined': 'keine festgelegt',
  // --- Flow ---
  'item.flow.gateClosed': 'An der Schwelle zu „{stage}“ ist noch nicht alles erfüllt.',
  'item.flow.strip': 'Ablauf: {flow}',
  'item.flow.somethingWrong': 'Etwas ist schiefgegangen.',
  'item.flow.unreached':
    'Die Aktion hat den Server nicht erreicht. Lade die Seite neu und versuche es noch einmal.',
  'item.flow.stageTipMeans': '{stage}: {state} · bedeutet {means}',
  'item.flow.stageTipManual': '{stage}: {state} · setzt nichts',
  'item.flow.current': 'aktuell',
  'item.asked': '{asked}: {statement}',
  'item.flow.state.passed': 'durchlaufen',
  'item.flow.state.current': 'aktuell',
  'item.flow.state.open': 'offen',
  'item.flow.state.blocked': 'gesperrt',
  'item.flow.gateHint.enforced':
    'Entscheidung nötig: Über diese Schwelle vorzurücken ist eine protokollierte Entscheidung der Entscheidenden (Verwaltende können trotzdem handeln, aber nur sichtbar, auf Stufe kritisch).',
  'item.flow.gateHint.open':
    'Offene Schwelle: Der Schritt gelingt immer; unerfüllte Erwartungen werden als Fakt festgehalten, nie blockiert.',
  'item.flow.deciderTip':
    'Entscheidende: {name} entscheidet an dieser Schwelle über das Vorrücken.',
  'item.flow.decisionRequired': 'Entscheidung nötig',
  'item.flow.decisionRequiredBy': 'Entscheidung nötig: {name}',
  'item.flow.decider': 'Entscheidende',
  'item.flow.deciderNamed': 'Entscheidende: {name}',
  'item.flow.restricted': 'verborgene Aufgabe',
  'item.flow.condition.accepted': 'abgenommen',
  'item.flow.condition.disputed': 'Abnahme verweigert',
  'item.flow.condition.notVisible': 'nicht sichtbar',
  'item.flow.condition.delivered': 'fertig',
  'item.flow.condition.notDelivered': 'offen',
  'item.flow.condition.waived': 'erlassen',
  'item.flow.waive': 'erlassen',
  'item.flow.waiveTitle':
    'Diese Bedingung für diese Aufgabe erlassen: ein protokollierter Ausweg, für immer sichtbar. Nur die Entscheidenden der Schwelle oder die Verantwortlichen können das.',
  'item.flow.advance': 'Hierher vorrücken',
  'item.flow.advanceTitle':
    'Die Aufgabe über diese Schwelle vorrücken lassen (die Schwelle entscheidet).',
  'item.flow.moveBack': 'Hierher zurück',
  'item.flow.moveBackTitle':
    'Die Aufgabe hierher zurückverschieben. Zurück geht immer und ist ein vollwertiger Schritt.',
  'item.flow.applies': 'setzt {means}',
  'item.flow.hold': 'Anhalten',
  'item.flow.holdTitle':
    'Ein Nein an dieser Schwelle festhalten: geprüft und entschieden, (noch) nicht vorzurücken. Nur die Entscheidenden der Schwelle oder die Verantwortlichen können das.',
  'item.flow.holdReason': 'Grund (optional)…',
  'item.flow.holdReasonLabel': 'Grund für das Anhalten',
  'item.flow.addWork': 'Aufgabe für {stage} hinzufügen',
  'item.flow.addWorkPlaceholder': 'Aufgabe für {stage} hinzufügen…',
  'item.flow.addWorkLabel': 'Aufgabe für die Phase {stage}',
  'item.flow.addWorkTitle':
    'Eine Aufgabe erstellen, die abgenommen sein muss, bevor die Schwelle dieser Phase frei ist.',
  'item.flow.add': 'Hinzufügen',
  'item.join.title': 'In einen Ablauf aufnehmen',
  'item.join.open': 'In einen Ablauf aufnehmen…',
  'item.join.search': 'Abläufe suchen…',
  'item.join.searchLabel': 'Abläufe zum Aufnehmen suchen',
  'item.join.noMatch': 'Kein passender Ablauf.',
  'item.join.shareBlocked': 'Teilen braucht Verantwortliche',
  'item.join.shareBlockedTitle':
    'Die Aufnahme teilt diese Aufgabe mit dem Personenkreis des Ablaufs. Dafür braucht es Verantwortliche der Aufgabe.',
  'item.join.into': 'In {flow} {id} aufnehmen',
  'item.join.hint':
    'Wo steht sie wirklich? Die Aufnahme legt nur die Position fest, keine Schwelle wird geprüft.',
  'item.join.atStage': 'In Phase aufnehmen',
  'item.join.back': 'Zurück',
  'item.join.confirm': 'Aufnehmen',
  'item.queue.label': 'Zur Besprechung vormerken',
  'item.queue.ceremony': 'Besprechung zum Vormerken',
  'item.queue.advance': 'Zu {stage} vorrücken',
  'item.queue.hold': 'Anhalten',
  'item.queue.unreached':
    'Die Aktion hat den Server nicht erreicht. Lade neu und versuche es noch einmal.',
  // --- Proposed changes ---
  'item.proposed.title': 'Änderungsvorschläge',
  'item.proposed.accept': 'Annehmen',
  'item.proposed.decline': 'Ablehnen',
  'item.proposed.empty': 'Für diese Aufgabe ist nichts vorgeschlagen.',
  'item.proposed.status.pending': 'offen',
  'item.proposed.status.applied': 'umgesetzt',
  'item.proposed.status.declined': 'abgelehnt',
  'item.proposed.status.superseded': 'ersetzt',
  'item.proposed.status.expired': 'abgelaufen',
  'item.proposed.open': 'Änderung vorschlagen',
  'item.proposed.fieldPick': 'Feld für den Vorschlag',
  'item.proposed.field.priority': 'Priorität',
  'item.proposed.field.acceptanceCriteria': 'Abnahmekriterien',
  'item.proposed.value': 'Vorgeschlagener Wert',
  'item.proposed.newValue': 'Neuer Wert',
  'item.proposed.clear': '(leeren)',
  'item.proposed.priority.must': 'muss',
  'item.proposed.priority.should': 'soll',
  'item.proposed.priority.could': 'kann',
  'item.proposed.target': 'Wohin damit',
  'item.proposed.now': 'Jetzt vorschlagen',
  'item.proposed.addTo': 'Hinzufügen zu: {plan}',
  'item.proposed.addToNew': 'Zu einem neuen Plan hinzufügen…',
  'item.proposed.newPlanName': 'Name des neuen Plans',
  'item.proposed.submit': 'Vorschlagen',
  'item.proposed.add': 'Hinzufügen',
  'item.proposed.cancel': 'Abbrechen',
  // --- Rail ---
  'item.rail.flowPosition': 'Position im Ablauf',
  'item.lineage.title': 'Stammbaum',
  'item.lineage.settings': 'Stammbaum-Einstellungen',
  'item.lineage.settingsChanged': 'Stammbaum-Einstellungen (geändert)',
  'item.lineage.depth': 'Tiefe',
  'item.lineage.depthDown': 'Weniger tief',
  'item.lineage.depthUp': 'Tiefer',
  'item.lineage.related': 'Verknüpfte Aufgaben',
  'item.lineage.hideRelated': 'Verknüpfte Aufgaben ausblenden',
  'item.lineage.showRelated': 'Verknüpfte Aufgaben anzeigen',
  'item.lineage.closed': 'Abgeschlossen',
  'item.lineage.hideClosed': 'Abgeschlossene ausblenden',
  'item.lineage.showRecentlyClosed': 'Kürzlich abgeschlossene anzeigen',
  'item.lineage.showClosed': 'Abgeschlossene anzeigen',
  'item.lineage.graph': 'Stammbaum als Grafik',
  'item.lineage.capped':
    'Nicht alle verknüpften Aufgaben gezeigt. Öffne die Landkarte für das ganze Netz.',
  // --- Sub-items ---
  'item.subItems.title': 'Unteraufgaben',
  'item.list.open': 'Als Checkliste öffnen',
  'item.subItems.digest': '{closed} von {total} abgeschlossen',
  'item.subItems.add': 'Unteraufgabe hinzufügen',
  'item.subItems.showClosed': {
    one: '{count} abgeschlossene anzeigen',
    other: '{count} abgeschlossene anzeigen',
  },
  'item.subItems.hideClosed': {
    one: '{count} abgeschlossene ausblenden',
    other: '{count} abgeschlossene ausblenden',
  },
  // --- Relationships ---
  'item.relationships.title': 'Beziehungen',
  'item.relationships.doorCritical': {
    one: ', davon eine kritisch',
    other: ', davon {count} kritisch',
  },
  'item.relationships.doorWarning': {
    one: ', davon eine mit Warnung',
    other: ', davon {count} mit Warnung',
  },
  'item.relationships.requests': 'Anfragen · {count}',
  'item.relationships.wantsParent': 'will diese als übergeordnete Aufgabe',
  'item.relationships.wantsDependency': 'will von dieser abhängen',
  'item.relationships.wantsRelated': 'will diese als verwandte Aufgabe',
  'item.relationships.requested': 'angefragt',
  'item.relationships.withdraw': 'zurückziehen',
  'item.relationships.approve': 'annehmen',
  'item.relationships.decline': 'ablehnen',
  'item.relationships.partOf': 'Teil von',
  'item.relationships.dependsOn': 'Hängt ab von',
  'item.relationships.neededBy': 'Davon hängt ab',
  'item.relationships.readyWaiting': {
    one: '1 bereit, wartet hierauf',
    other: '{count} bereit, warten hierauf',
  },
  'item.relationships.subItems': 'Unteraufgaben',
  'item.relationships.related': 'Verwandt',
  'item.relationships.rowSheet': 'Beziehung zu „{title}“',
  'item.relationships.reshape': 'Beziehung ändern…',
  'item.relationships.promise': 'Zur Zusage machen…',
  'item.relationships.uncontain': '„Nicht betroffen“ entfernen',
  'item.relationships.stub.notShared': 'Nicht mit dir geteilt.',
  'item.relationships.stub.requester': 'Verantwortlich',
  'item.relationships.stub.requestAccess': 'Zugriff anfragen',
  'item.relationships.orphanContained': 'Nicht betroffen, nicht mehr verknüpft',
  'item.relationships.addGhost': 'Beziehung hinzufügen…',
  'item.relationships.addField': 'Beziehung hinzufügen',
  'item.relationships.type': 'Art der Beziehung',
  'item.relationships.add.sub': 'Unteraufgabe',
  'item.relationships.add.subPlaceholder':
    'Unteraufgabe hinzufügen: Namen eingeben und Enter drücken…',
  'item.relationships.add.parentPlaceholder': 'Teil von: Namen eingeben und Enter drücken…',
  'item.relationships.add.blockerPlaceholder': 'Hängt ab von: Namen eingeben und Enter drücken…',
  'item.relationships.add.feedsPlaceholder': 'Davon hängt ab: Namen eingeben und Enter drücken…',
  'item.relationships.add.relatedPlaceholder': 'Verwandt: Namen eingeben und Enter drücken…',
  'item.relationships.addButton': 'hinzufügen',
  'item.relationships.orLink': 'oder eine vorhandene Aufgabe verknüpfen',
  'item.relationships.linkAs': 'als {kind} verknüpfen',
  'item.relationships.somethingWrong': 'Etwas ist schiefgegangen.',
  'item.relationships.notSaved': 'Nicht gespeichert. Erneut versuchen',
  'item.relationships.dialogTitle': 'Beziehung',
  'item.relationships.with': 'Mit {title}',
  'item.relationships.current': ' · aktuell',
  'item.relationships.shape.sub': 'Unteraufgabe',
  'item.relationships.shape.subHint': 'liegt darunter und zählt in diese Aufgabe ein',
  'item.relationships.shape.parent': 'Teil von',
  'item.relationships.shape.parentHint': 'diese Aufgabe liegt darin',
  'item.relationships.shape.blocker': 'Hängt ab von',
  'item.relationships.shape.blockerHint': 'diese Aufgabe braucht sie erledigt',
  'item.relationships.shape.feeds': 'Davon hängt ab',
  'item.relationships.shape.feedsHint': 'sie braucht diese Aufgabe erledigt',
  'item.relationships.shape.related': 'Verwandt',
  'item.relationships.shape.relatedHint': 'eine lose Verknüpfung, keine Abhängigkeit',
  'item.relationships.sentForApproval':
    'Zur Bestätigung gesendet: Die andere Seite muss die neue Verknüpfung annehmen.',
  'item.relationships.removeLink': 'Verknüpfung entfernen',
  'item.relationships.cancel': 'Abbrechen',
  'item.relationships.apply': 'Übernehmen',
  'item.relationships.move': '„{title}“ verschieben',
  'item.relationships.moveUnreached':
    'Die Verschiebung hat den Server nicht erreicht. Versuche es noch einmal.',
  // --- Activity ---
  'item.activity.title': 'Verlauf',
  // --- Dock ---
  'item.dock.back': 'Zurück',
  'item.dock.done': 'Fertig',
  'item.dock.about': 'Zu dieser Aufgabe',
  'item.dock.thisItem': 'Diese Aufgabe',
  'item.dock.rename': 'Umbenennen',
  'item.dock.access': 'Zugriff',
  'item.dock.nextStep': 'Nächster Schritt',
  'item.menu.label': 'Aktionen zur Aufgabe',
  'item.menu.more': 'Weitere Aktionen',
  'item.menu.propose': 'Änderung vorschlagen…',
  'item.menu.openInNewTab': 'In neuem Tab öffnen',
  'item.menu.addNote': 'Notiz hinzufügen',
  'item.menu.editNote': 'Notiz bearbeiten',
  'item.notify.row': 'Benachrichtigungen…',
  'item.notify.label': 'Benachrichtigungen',
  'item.notify.subscribe': 'Abonnieren',
  'item.notify.default': 'Standard',
  'item.notify.hide': 'Stummschalten',
  'item.acts.sheet': 'Aktionen für diese Aufgabe',
  'item.acts.outOfRole': 'nicht zuständig',
  'item.acts.requesterOnly': 'nur Verantwortliche',
  'item.acts.requesterOnlyTitle': 'Nur Verantwortliche können das abbrechen',
  'item.acts.viewOnly': 'nur ansehen',
  'item.acts.closesAbove': '+{count} darüber',
  'item.acts.closeAll': 'Alle fertigstellen?',
  'item.error.unknownGrade': 'Unbekannte Stufe.',
  'item.error.renameNeedsQuestion':
    'Diese Umbenennung braucht eine Rückfrage, die der Titel nicht stellen kann.',
  'item.error.inviteMailFailed':
    'Die Einladung ist gespeichert, aber die E-Mail konnte nicht gesendet werden. Lade noch einmal ein.',
} as const satisfies AreaCatalog<typeof en>;
